import { AppBar, Container, Divider, Stack } from "@mui/material";
import ProductCard from "./ProductCard";
import LoadingBox from "./LoadingBox";
import CanvasControls from "./CanvasControls";
import CanvasMediaButton from "./CanvasMediaButton";
import CheckoutForm from "./Checkout/CheckoutForm";

const containerStyles = {
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  padding: theme => ({
    // xs: theme.spacing(1, 2),
    // md: theme.spacing(1, 2) 
  }),
};

function SidebarBottom() {
  return (
    <>
      <AppBar position="static">
        <LoadingBox>
          <CanvasControls />
          <Divider style={{ margin: 0 }} />
          <Container sx={containerStyles}>
            <ProductCard />
            <Stack direction={'row'} alignItems={'center'}>
              <CanvasMediaButton />
              <CheckoutForm />
            </Stack>
          </Container>
        </LoadingBox>
      </AppBar>
    </>
  );
};

export default SidebarBottom;